import $ from 'jquery';
import '../vendor/jquery.ba-dotimeout.min';
import ImageBackgrounds from './ImageBackgrounds';
import SlickControls from './SlickPlayPauseControls';

const defaults = {
  speed: 1000,
  fade: true,
  slide: '.views-row',
  autoplay: true,
  autoplaySpeed: 5000,
  dots: true,
  dotsClass: 'dots',
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  pauseOnHover: false,
  pauseOnFocus: false,
  waitForAnimate: false,
};

function Carousel(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = $.extend(true, {}, defaults, options);
  this.init();
}

Carousel.prototype = {
  init() {
    this.build();
    this.ready();
  },
  preprocess() {
    const $rows = this.$element.find(this.settings.slide);
    this.element.imageBackgrounds = new ImageBackgrounds($rows, {
      source: '.field-image.c2 img',
    });
  },
  build() {
    const $slick = this.$element.find('.view-content');

    // Event that happens before the initialization of the slick instance
    $slick.on('init', () => {
      // Prepare the markup
      this.preprocess();

      // Clear out the initial caption that is currently set.
      $slick.find('.field-image .caption').text('');

      // Go ahead and set our dot animation to start on the currently active slide
      this.$element.find('.dots .slick-active').addClass('active');

      // Kick off the initial url to be typed in.
      $slick.doTimeout('init', this.settings.speed, () => {
        this.enterUrl(0);
      });
    });

    // Event that happens before the slide changes
    $slick.on('beforeChange', (event, slick, currentIndex) => {
      this.clearUrl(currentIndex);
      this.manageDotNavStatesBeforeChange();
    });

    // Event that happens after the slide changes
    $slick.on('afterChange', (event, slick, currentIndex) => {
      this.enterUrl(currentIndex);
      this.manageDotNavStatesAfterChange();
    });

    // Create a new slick instance
    $slick.slick(this.settings);

    // We'd like to update the dots immediately when a dot is clicked.
    $slick.find('.dots li').bind('click', () => {
      $(this).prevAll().addClass('prev-active').removeClass('active');
    });

    // Add Slick Play and Pause controls since we are auto-advancing the carousel
    this.element.slickControls = new SlickControls($slick);
  },
  ready() {
    this.$element.addClass('ready');
  },
  clearUrl(index) {
    const $slide = this.$element.find(this.settings.slide).eq(index);
    $slide.find('.field-image.c1 .caption').text('');
  },
  enterUrl(index) {
    let i = 0;
    const $slide = this.$element.find(this.settings.slide).eq(index);
    const url = $slide.find('.field-image.c1 img').attr('title');
    const $caption = $slide.find('.field-image.c1 .caption');

    // Animate in the url into the browser ui graphic
    $slide.doTimeout('typing', 60, () => {
      if (i <= url.length) {
        $caption.text(url.substr(0, i));
        i += 1;
        return true;
      }
      return false;
    });
  },
  manageDotNavStatesBeforeChange() {
    const $dots = this.$element.find('.dots li');
    const $current = $dots.filter('.slick-active');
    $current.addClass('prev-active').removeClass('active');
    if (!$current.nextAll().length) {
      $dots.removeClass('prev-active active');
    }
  },
  manageDotNavStatesAfterChange() {
    const $current = this.$element.find('.dots .slick-active');
    $current.removeClass('prev-active').addClass('active');
    $current.prevAll().addClass('prev-active').removeClass('active');
    $current.nextAll().removeClass('prev-active active');
  },
};

export default Carousel;



// WEBPACK FOOTER //
// ./FeaturedCarousel.js